/**
 * CUSTOMER FIX Stage 7 — best-effort shop href for registry rows / switcher fallback.
 */

/** Phone-first shop URL when slug is unknown. */
export function buildDefaultShopHref(tenantCode: string, kioskId: number): string {
  return `/${encodeURIComponent(tenantCode)}/shop?kioskId=${encodeURIComponent(String(kioskId))}`;
}

export function buildShopCartSaveHref(input: {
  readonly tenantCode: string;
  readonly kioskId: number;
  readonly routeSlug?: string;
  readonly salesPointCode?: string | null;
}): string {
  const slug = input.routeSlug?.trim() || input.salesPointCode?.trim() || '';
  if (slug.length > 0) {
    return `/${encodeURIComponent(input.tenantCode)}/${encodeURIComponent(slug)}`;
  }
  return buildDefaultShopHref(input.tenantCode, input.kioskId);
}
